/* eslint-disable
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import NoteConstants from 'notebook/notes/NoteConstants';
import PreviewMixin from 'notebook/notes/previews/PreviewMixin';
import React from 'react';

import createReactClass from 'create-react-class';

const SequencePreview = createReactClass({
  mixins: [PreviewMixin],
  className: 'note-sequence',
  noteType: NoteConstants.SEQUENCE,

  renderItem() {
    const sequence = this.props.item;
    return (
      <div className="note-preview-body">
        <img src={sequence.snapshot_url} />
      </div>
    );
  },
});

export default SequencePreview;
